import * as Accordion from '@radix-ui/react-accordion';
import { LinkProps } from 'next/link';

import { ChevronDown } from './chevron-down';
import styles from './locations.module.css';
import { useBottomNavigation } from '../../../../bottom-navigation.context';

export type LocationsProps = {
  countries: Array<{
    countryName: string;
    cities: Array<{
      cityName: string;
      href: LinkProps['href'];
    }>;
  }>;
};
export const Locations = ({ countries }: LocationsProps) => {
  const { linkFactory } = useBottomNavigation();

  return (
    <div>
      <Accordion.Root type="single" collapsible className={styles.accordion}>
        {countries?.map(({ countryName, cities }) => (
          <Accordion.Item key={countryName} value={countryName}>
            <Accordion.Trigger className={styles.trigger}>
              <span>{countryName}</span>
              <ChevronDown />
            </Accordion.Trigger>

            <Accordion.Content className={styles.accordionContent}>
              {cities.map(({ cityName, href }) =>
                linkFactory({ href, key: cityName, className: styles.link, children: cityName }),
              )}
            </Accordion.Content>
          </Accordion.Item>
        ))}
      </Accordion.Root>
    </div>
  );
};
